import styled from 'styled-components';
export const DownCaratIconWrapper = styled.span.withConfig({
  displayName: "HeaderTitlestyle__DownCaratIconWrapper",
  componentId: "sc-1s92xme-0"
})(["display:flex;align-items:center;transition:0.3s;transform:rotate( ", "deg );"], ({
  isPreviousMeetingsMenuOpen
}) => isPreviousMeetingsMenuOpen ? 180 : 0);